import React, { useEffect, useRef, useState } from "react";
import EmojiPicker from "emoji-picker-react";
import Message from "./Message";
import { useDispatch, useSelector } from "react-redux";
import {
  chatGroupUserList,
  getGroupMessageList,
} from "../../../../redux/actions/chat";
import { socket } from "../../../../service/socket";
import CustomeModal from "../../../../component/modal-popup/customeModal";
import swal from "@sweetalert/with-react";
import axios from "axios";

const MainBody = ({ activeGroup, msgList, page, setPage, hasMoreRef }) => {
  const dispatch = useDispatch();
  const [emojiWindow, setEmojiWindow] = useState(false);
  const [users, setUsers] = useState([]);
  const { id, email, token } = useSelector((state) => state.auth);
  const { performancedata } = useSelector((state) => state.todoPerformance);

  // State for message
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("text");
  const [sendButtonDisable, setSendButtonDisable] = useState(false);
  const [fileValue, setFileValue] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [showThumbnail, setShowThumbnail] = useState("");
  const [docType, setDocType] = useState("");

  // Infinite Scrolling with pagination
  const [loading, setLoading] = useState(false);
  const pageLimit = 20;
  const containerRef = useRef(null);
  // const hasMoreRef = useRef(true);
  
  useEffect(() => {
    const container = containerRef.current;
    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, []);

  const handleScroll = () => {
    const container = containerRef.current;
    console.log("HasMore Ref: ", hasMoreRef.current)
    if (Math.abs(container.scrollTop) + container.clientHeight === (container.scrollHeight - 1) && Math.abs(container.scrollTop) !== 0) {
      if (!loading && hasMoreRef.current) {
        hasMoreRef.current = false;
        setPage(prev => prev + 1);
      }
    }
  }

  useEffect(() => {
    if (Object.keys(activeGroup).length !== 0 && activeGroup?.user_ids) {
      dispatch(
        chatGroupUserList({ ids: JSON.parse(activeGroup.user_ids) }, (res) => {
          if (res.data) {
            setUsers(res.data);
          }
        })
      );
    }

    return () => {
      setUsers([]);
    };
  }, [activeGroup]); 

  useEffect(() => {
    if (Object.keys(activeGroup).length !== 0) {
      setLoading(true);
      const payload = {
        main_group_id: activeGroup.main_group_id,
        sub_group_id: activeGroup.sub_group_id,
      };
      dispatch(getGroupMessageList(payload, page, pageLimit, (res) => {
        setLoading(false);
        hasMoreRef.current = true;
        if(res.data.totalPages === page){
          hasMoreRef.current = false;
          // setHasMore(false);
        }
      }));
    }
  }, [activeGroup, page]);

  const handleEmojiClick = (event, emojiObject) => {
    setMessage((prev) => prev + emojiObject.emoji);
  };

  // Message Input onChange Handler
  const handleOnChange = (e) => {
    if(messageType !== "text"){
      setMessageType("text");
      setSelectedFile("");
    }
    setMessage(e.target.value);
  };

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      handleSend();
    }
  };

  const handleSend = async (e) => {
    
    setSendButtonDisable(true);

    let msg = message;

    if (messageType === "file") {
      msg = await getFilePayload();
    }

    if (msg === "") {
      return;
    }


    const emails_data = JSON.parse(activeGroup.user_emails);
    const is_read_emails = emails_data.filter((item) => item !== email);

    const payload = {
      company_id: activeGroup.company_id,
      main_group_id: activeGroup.main_group_id,
      sub_group_id: activeGroup.sub_group_id,
      sender: id,
      sender_email: email,
      message_type: messageType,
      message: msg,
      is_read: JSON.stringify(is_read_emails),
      activity_assignment_id: performancedata.activity_assignment_id
    };
    setMessageType("text");
    setMessage("");
    setEmojiWindow(false);
    setSendButtonDisable(false);
    socket.emit("send_group_message", payload);
  };

  const handleUpload = (file) => {
    setFileValue("");
    setMessage("");
    const maxFileSize = 4 * 1024 * 1024;
    if (file.size > maxFileSize) {
      swal({
        content: (
          <CustomeModal
            type="warning"
            title="Warning!"
            content={`${file.name} file exceeds upload limit of 4 MB.`}
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
      return;
    }

    setMessageType("file");
    setSelectedFile(file);
    if (file.type.split("/")[0] === "image") {
      setShowThumbnail("image");
      setDocType("image");
    } else if (file.type.split("/")[0] === "video") {
      setShowThumbnail("video");
      setDocType("video");
    } else {
      setShowThumbnail("docs");
      setDocType("docs");
    }
  };

  const getFilePayload = async () => {
    const formData = new FormData();
    formData.append("file", selectedFile);
    const result = await axios.post(
      `${process.env.REACT_APP_API_URL}/upload/chat`,
      formData,
      {
        headers: {
          "content-type": "multipart/form-data",
          "Authorization": `Bearer ${token}`
        },
      }
    );
    const payload = {
      path: result.data.key,
      type: docType,
    };
    setMessage("");
    setDocType("");
    setMessageType("text");
    setSelectedFile("");
    return JSON.stringify(payload);
  }

  return (
    // border border-green-500
    <div className="relative w-full h-full flex flex-col transition-transform duration-300 ease-in-out pl-3 pb-1 pt-3">
      {/* Header Title with user's name */}
      <div className="w-full h-16 flex items-center space-x-3">
        <div>
          <div
            className={`w-[44px] h-[44px] flex justify-center items-center rounded-full text-white bg-[#2F80ED]`}
          >
            <span className="fa-solid fa-user-group"></span>
          </div>
        </div>
        <div>
          <div className="w-full h-full flex flex-col">
            <div className="font-inter font-bold text-base text-[#1E293B]">
              {activeGroup.group_name}
            </div>
            <div className="font-inter font-normal text-xs text-[#78818F] line-clamp-1">
              {users.map((item) => item.name).join(", ")}
            </div>
          </div>
        </div>
      </div>

      {/* Main Message Area */}
      <div ref={containerRef} className="h-full flex flex-col-reverse overflow-y-auto scroll-smooth scrollbar scrollbar-w-2 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-100">
        {msgList.map((item) => (
          item.sub_group_id === activeGroup.sub_group_id && (
            <Message
              key={item.chat_id}
              is_sender={item?.sender_email === email ? true : false}
              message={item}
              users={users}
            />
          )
        ))}
        {loading && (
          <div className="w-full flex justify-center items-center pt-5 py-2">
            <span className="ml-2">
              <svg className="animate-spin w-6 h-6 fill-current shrink-0" viewBox="0 0 16 16">
                <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
              </svg>
            </span>
          </div>
        )}
        {page > 1 && !loading && !hasMoreRef.current && <p className="text-center text-sm font-inter py-3 text-[#1E293B]">No more message to load</p>}
      </div>
      {/* Bottom message area */}
      <div className="sticky w-full h-[60px] rounded-md bg-[--bg-color-50] my-2">
        <div className="w-full flex items-center justify-between px-4 sm:px-6 md:px-5 h-16">
          {/* Message input */}
          <div className="grow flex items-center">
          <div>
              <label htmlFor="file">
                <span className="fa-regular fa-paperclip text-[20px] pr-5 cursor-pointer"></span>
              </label>
              <input
                type="file"
                value={fileValue}
                onChange={(e) => {
                  setFileValue(e.target.files);
                  handleUpload(e.target.files[0]);
                }}
                hidden
                id="file"
              />
            </div>
            <div className="grow mr-3">
              <label htmlFor="message-input" className="sr-only">
                Type a message
              </label>
              <div className="relative">
                <input
                  id="message-input"
                  className="form-input w-full !pr-10 bg-white border-slate-200 focus:border-slate-300"
                  type="text"
                  placeholder="Message"
                  value={message}
                  onChange={handleOnChange}
                  onKeyDown={handleEnter}
                />
                <div className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer">
                  <span
                    className="fa-sharp fa-regular fa-face-smile text-[#535353] text-[20px]"
                    onClick={(e) => {
                      e.preventDefault();
                      setEmojiWindow(true);
                    }}
                  ></span>
                </div>
              </div>
            </div>
            <button
              disabled={sendButtonDisable}
              className="btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white whitespace-nowrap"
              onClick={handleSend}
            >
              Send
            </button>
          </div>
        </div>
      </div>

      {/* Emoji Window with close button */}
      {emojiWindow && (
        <div className="duration-300 ease-in-out">
          <div
            className="bg-white flex justify-end pr-3 pb-1"
            onClick={(e) => {
              e.stopPropagation();
              setEmojiWindow(false);
              // setMessageType("text");
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              className="w-6 h-6 cursor-pointer"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>
          <div className="">
            <EmojiPicker
              pickerStyle={{
                width: "100%",
                boxShadow: "none",
                borderRadius: "none",
              }}
              onEmojiClick={handleEmojiClick}
            />
          </div>
        </div>
      )}

      {selectedFile && (
        <div className="duration-300 ease-in-out">
          <div
            className="bg-white flex justify-end pr-3 pb-1"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedFile("");
              setMessageType("text");
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              className="w-6 h-6 cursor-pointer"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>
          <div className="w-full h-[200px] bg-white p-3 flex flex-col justify-center items-center">
            {showThumbnail === "image" && (
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-40 h-40"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
                  />
                </svg>
              </div>
            )}
            {showThumbnail === "video" && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-40 h-40"
              >
                <path
                  strokeLinecap="round"
                  d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z"
                />
              </svg>
            )}
            {showThumbnail === "docs" && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                class="w-40 h-40"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"
                />
              </svg>
            )}
            <div className="pt-2">{selectedFile.name}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MainBody;
